
import React, { useEffect, useRef } from 'react';
import Prism from 'prismjs';

import 'prismjs/themes/prism-tomorrow.css';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-jsx';
import 'prismjs/components/prism-tsx';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-json';
import 'prismjs/components/prism-bash';

interface SyntaxHighlighterProps {
  code: string;
  language: string;
  filename?: string;
}

const SyntaxHighlighter: React.FC<SyntaxHighlighterProps> = ({ code, language, filename }) => {
  const codeRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (codeRef.current) {
      Prism.highlightElement(codeRef.current);
    }
  }, [code, language]);

  return (
    <div className="code-editor">
      {filename && (
        <div className="code-editor-header">
          <span className="code-editor-filename">{filename}</span>
        </div>
      )}
      <div className="code-editor-content syntax-highlighted">
        <pre className={`language-${language}`}>
          <code ref={codeRef} className={`language-${language}`}>
            {code}
          </code>
        </pre>
      </div>
    </div>
  );
};

export default SyntaxHighlighter;